import React from "react";
import { LayoutGrid, List } from "lucide-react";
import "./ViewToggle.scss";

/**
 * ViewToggle — Reusable grid/list view toggle.
 * Matches UX_DESIGNS ViewToggle component.
 *
 * Props:
 *   view       — "grid" | "list"
 *   onViewChange — callback(newView)
 *   className  — extra class
 */
const ViewToggle = ({ view, onViewChange, className = "" }) => {
  return (
    <div className={`view-toggle ${className}`}>
      <button
        type="button"
        className={`view-toggle__btn ${view === "grid" ? "view-toggle__btn--active" : ""}`}
        onClick={() => onViewChange("grid")}
        aria-label="Grid view"
      >
        <LayoutGrid size={16} />
      </button>
      <button
        type="button"
        className={`view-toggle__btn ${view === "list" ? "view-toggle__btn--active" : ""}`}
        onClick={() => onViewChange("list")}
        aria-label="List view"
      >
        <List size={16} />
      </button>
    </div>
  );
};

export default ViewToggle;
